import { render } from "./closeThePageModal.vue?vue&type=template&id=f2a7e35c&scoped=true"
import script from "./closeThePageModal.vue?vue&type=script&lang=js"
export * from "./closeThePageModal.vue?vue&type=script&lang=js"

import "./closeThePageModal.vue?vue&type=style&index=0&id=f2a7e35c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a7e35c"]])

export default __exports__